import _styled from "styled-components";
import { useMemo } from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import { customImageLoader, formatDateToDayMonthYear } from '@restworld/utils-common';
import { Avatar, Badge } from '@restworld/ui-ds-base';
import { Title } from '../title';
import { ImagePlaceholder } from '../image-placeholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerSpontaneousCandidateCard(_ref) {
  var candidate = _ref.candidate,
      restaurantCount = _ref.restaurantCount,
      restaurant = _ref.restaurant,
      appliedDate = _ref.appliedDate,
      isHidden = _ref.isHidden,
      onClick = _ref.onClick,
      isNewCandidate = _ref.isNewCandidate;
  var hasMultipleRestaurants = restaurantCount > 1;
  return /*#__PURE__*/_jsxs(CardWrappper, {
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(CardHeader, {
      appliedDate: appliedDate,
      firstName: candidate === null || candidate === void 0 ? void 0 : candidate.firstName,
      lastName: candidate === null || candidate === void 0 ? void 0 : candidate.lastName,
      isHidden: isHidden,
      isNewCandidate: isNewCandidate
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      children: [/*#__PURE__*/_jsx(CardInfoSection, {
        candidateDistanceToRestaurant: candidate === null || candidate === void 0 ? void 0 : candidate.distanceToRestaurant,
        candidateEmail: candidate === null || candidate === void 0 ? void 0 : candidate.email,
        candidateImage: candidate === null || candidate === void 0 ? void 0 : candidate.image,
        candidatePhone: candidate === null || candidate === void 0 ? void 0 : candidate.phone,
        candidateFirstName: candidate === null || candidate === void 0 ? void 0 : candidate.firstName,
        candidateLastName: candidate === null || candidate === void 0 ? void 0 : candidate.lastName
      }), hasMultipleRestaurants && /*#__PURE__*/_jsx(CardAppliedToSection, {
        restaurantAddress: restaurant === null || restaurant === void 0 ? void 0 : restaurant.address,
        restaurantLogo: restaurant.logo,
        restaurantName: restaurant === null || restaurant === void 0 ? void 0 : restaurant.name
      })]
    })]
  });
}
export default EmployerSpontaneousCandidateCard;

function CardWrappper(_ref2) {
  var children = _ref2.children,
      onClick = _ref2.onClick;
  return /*#__PURE__*/_jsx(StyledButton, {
    onClick: onClick,
    children: children
  });
}

function CardHeader(_ref3) {
  var firstName = _ref3.firstName,
      lastName = _ref3.lastName,
      isHidden = _ref3.isHidden,
      appliedDate = _ref3.appliedDate,
      isNewCandidate = _ref3.isNewCandidate;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var formattedDate = useMemo(function () {
    return formatDateToDayMonthYear(appliedDate);
  }, [appliedDate]);
  return /*#__PURE__*/_jsxs(CardHeaderWrapper, {
    children: [/*#__PURE__*/_jsx(Title, {
      textColor: "neutral-700",
      fontSize: "large",
      fontWeight: "semibold",
      twStyle: {
        "fontSize": "1.125rem",
        "lineHeight": "1.75rem"
      },
      children: "".concat(firstName, " ").concat(lastName)
    }), /*#__PURE__*/_jsxs(BadgesWrapper, {
      children: [isHidden && /*#__PURE__*/_jsx(Badge, {
        variant: "disabled",
        children: t('discarded')
      }), isNewCandidate && /*#__PURE__*/_jsx(_StyledBadge, {
        variant: "warning",
        children: t('new')
      }), /*#__PURE__*/_jsx(Badge, {
        variant: "neutral",
        children: "".concat(t('applied_on'), " ").concat(formattedDate)
      })]
    })]
  });
}

function CardInfoSection(_ref4) {
  var candidateDistanceToRestaurant = _ref4.candidateDistanceToRestaurant,
      candidateEmail = _ref4.candidateEmail,
      candidateImage = _ref4.candidateImage,
      candidatePhone = _ref4.candidatePhone,
      candidateFirstName = _ref4.candidateFirstName,
      candidateLastName = _ref4.candidateLastName;
  return /*#__PURE__*/_jsxs(InfoSectionWrapper, {
    children: [/*#__PURE__*/_jsx(Avatar, {
      src: candidateImage,
      firstName: candidateFirstName,
      lastName: candidateLastName,
      size: "lg"
    }), /*#__PURE__*/_jsxs(CandidateInfoWrapper, {
      children: [/*#__PURE__*/_jsx(Title, {
        icon: "MapPinIconGray",
        textColor: "neutral-200",
        fontSize: "small",
        fontWeight: "medium",
        twStyle: {
          "textAlign": "left",
          "fontSize": "0.875rem",
          "lineHeight": "1.25rem"
        },
        children: candidateDistanceToRestaurant
      }), /*#__PURE__*/_jsx(Title, {
        icon: "PhoneIcon",
        textColor: "neutral-200",
        fontSize: "small",
        fontWeight: "medium",
        twStyle: {
          "textAlign": "left",
          "fontSize": "0.875rem",
          "lineHeight": "1.25rem"
        },
        children: candidatePhone
      }), /*#__PURE__*/_jsx(Title, {
        icon: "EnvelopeIcon",
        textColor: "neutral-200",
        fontSize: "small",
        fontWeight: "medium",
        twStyle: {
          "width": "100%",
          "maxWidth": "165px",
          "overflow": "hidden",
          "textOverflow": "ellipsis",
          "whiteSpace": "nowrap",
          "textAlign": "left",
          "fontSize": "0.875rem",
          "lineHeight": "1.25rem",
          "@media (min-width: 1024px)": {
            "maxWidth": "184px"
          }
        },
        children: candidateEmail
      })]
    })]
  });
}

function CardAppliedToSection(_ref5) {
  var restaurantAddress = _ref5.restaurantAddress,
      restaurantLogo = _ref5.restaurantLogo,
      restaurantName = _ref5.restaurantName;

  var _useTranslation2 = useTranslation('common'),
      t = _useTranslation2.t;

  return /*#__PURE__*/_jsxs(AppliedToSectionWrapper, {
    children: [/*#__PURE__*/_jsxs(Title, {
      textColor: "neutral-200",
      fontWeight: "medium",
      fontSize: "small",
      twStyle: {
        "fontSize": "0.875rem",
        "lineHeight": "1.25rem"
      },
      children: [t('spontaneously_applied_to'), ":"]
    }), /*#__PURE__*/_jsxs(AppliedToContentWrapper, {
      children: [/*#__PURE__*/_jsx(LogoWrapper, {
        children: restaurantLogo ? /*#__PURE__*/_jsx(_StyledImage, {
          src: restaurantLogo,
          alt: "",
          fill: true,
          loader: customImageLoader
        }) : /*#__PURE__*/_jsx(ImagePlaceholder, {
          wrapperStyle: {
            "height": "fit-content",
            "width": "fit-content"
          },
          iconClasses: "h-7 w-7 fill-purple-100"
        })
      }), /*#__PURE__*/_jsxs(RestaurantInfoWrapper, {
        children: [/*#__PURE__*/_jsx(Title, {
          textColor: "neutral-700",
          fontWeight: "semibold",
          fontSize: "small",
          twStyle: {
            "textAlign": "left",
            "fontSize": "0.875rem",
            "lineHeight": "1.25rem"
          },
          children: restaurantName
        }), /*#__PURE__*/_jsx(Title, {
          textColor: "neutral-700",
          fontWeight: "normal",
          fontSize: "small",
          twStyle: {
            "maxWidth": "100%",
            "overflow": "hidden",
            "textOverflow": "ellipsis",
            "whiteSpace": "nowrap",
            "textAlign": "left",
            "fontSize": "0.875rem",
            "lineHeight": "1.25rem"
          },
          children: restaurantAddress
        })]
      })]
    })]
  });
}

var StyledButton = /*#__PURE__*/_styled.button.withConfig({
  displayName: "employer-spontaneous-candidate-card__StyledButton",
  componentId: "sc-13ftqkr-0"
})(["", ""], {
  "display": "block",
  "width": "100%",
  "appearance": "none",
  "borderRadius": "1rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))",
  "padding": "1rem",
  "--tw-shadow": "0px 2px 4px 0px rgba(0,0,26,0.05)",
  "--tw-shadow-colored": "0px 2px 4px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  ":hover": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))",
    "--tw-shadow": "0px 2px 4px 0px rgba(0,0,26,0.05),inset 0 0 0 2px #6633bb",
    "--tw-shadow-colored": "0px 2px 4px 0px var(--tw-shadow-color), inset 0 0 0 2px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  }
});

var ContentWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__ContentWrapper",
  componentId: "sc-13ftqkr-1"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "@media (min-width: 1024px)": {
    "flexDirection": "row"
  }
});

var CardHeaderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__CardHeaderWrapper",
  componentId: "sc-13ftqkr-2"
})(["", ""], {
  "marginBottom": "0.75rem",
  "display": "flex",
  "flexDirection": "column",
  "justifyContent": "space-between",
  "@media (min-width: 1024px)": {
    "flexDirection": "row"
  }
});

var BadgesWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__BadgesWrapper",
  componentId: "sc-13ftqkr-3"
})(["", ""], {
  "marginTop": "0.75rem",
  "display": "flex",
  "alignItems": "center",
  "gap": "0.75rem",
  "@media (min-width: 1024px)": {
    "marginTop": "0px"
  }
});

var InfoSectionWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__InfoSectionWrapper",
  componentId: "sc-13ftqkr-4"
})(["", ""], {
  "display": "flex",
  "gap": "0.75rem",
  "@media (min-width: 1024px)": {
    "width": "335px",
    "minWidth": "335px",
    "maxWidth": "335px",
    "paddingRight": "1.5rem"
  }
});

var CandidateInfoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__CandidateInfoWrapper",
  componentId: "sc-13ftqkr-5"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "justifyContent": "center",
  "gap": "0.75rem"
});

var AppliedToSectionWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__AppliedToSectionWrapper",
  componentId: "sc-13ftqkr-6"
})(["", ""], {
  "marginTop": "0.75rem",
  "width": "100%",
  "borderTopWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "paddingTop": "0.75rem",
  "@media (min-width: 1024px)": {
    "marginTop": "0px",
    "borderLeftWidth": "1px",
    "borderTopWidth": "0px",
    "paddingLeft": "1.5rem",
    "paddingTop": "0px"
  }
});

var AppliedToContentWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__AppliedToContentWrapper",
  componentId: "sc-13ftqkr-7"
})(["", ""], {
  "marginTop": "0.75rem",
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))",
  "padding": "1rem",
  "@media (min-width: 1024px)": {
    "flexDirection": "row",
    "gap": "1rem"
  }
});

var RestaurantInfoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__RestaurantInfoWrapper",
  componentId: "sc-13ftqkr-8"
})(["", ""], {});

var LogoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-spontaneous-candidate-card__LogoWrapper",
  componentId: "sc-13ftqkr-9"
})(["", ""], {
  "position": "relative",
  "display": "flex",
  "height": "2.5rem",
  "width": "2.5rem",
  "minWidth": "2.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "objectFit": "cover",
  "objectPosition": "center"
});

var _StyledBadge = /*#__PURE__*/_styled(Badge).withConfig({
  displayName: "employer-spontaneous-candidate-card___StyledBadge",
  componentId: "sc-13ftqkr-10"
})({
  "textTransform": "capitalize"
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "employer-spontaneous-candidate-card___StyledImage",
  componentId: "sc-13ftqkr-11"
})({
  "objectFit": "cover",
  "objectPosition": "center"
});